import api from "../config/api";
import type { ApiResponse, Customer, PaginatedResponse } from "../types";

export interface CreateCustomerRequest {
  name: string;
  phone: string;
  email?: string;
  dateOfBirth?: string;
  gender?: 'male' | 'female' | 'other';
  address?: string;
  notes?: string;
  referredBy?: string;
}

export interface GetCustomersParams {
  page?: number;
  limit?: number;
  search?: string;
  status?: string;
}

export const customerService = {
  getCustomers: async (params: GetCustomersParams = {}): Promise<PaginatedResponse<Customer>> => {
    const response = await api.get('/customers', { params });
    return response.data;
  },

  getCustomer: async (id: string): Promise<ApiResponse<{ customer: Customer; activeCourses: any[] }>> => {
    const response = await api.get(`/customers/${id}`);
    return response.data;
  },

  createCustomer: async (data: CreateCustomerRequest): Promise<ApiResponse<Customer>> => {
    const response = await api.post('/customers', data);
    return response.data;
  },

  updateCustomer: async (id: string, data: Partial<CreateCustomerRequest>): Promise<ApiResponse<Customer>> => {
    const response = await api.put(`/customers/${id}`, data);
    return response.data;
  },

  deleteCustomer: async (id: string): Promise<ApiResponse<Customer>> => {
    const response = await api.delete(`/customers/${id}`);
    return response.data;
  },

  getCustomerCourses: async (id: string, active = true): Promise<ApiResponse<any[]>> => {
    const response = await api.get(`/customers/${id}/courses`, { params: { active } });
    return response.data;
  },

  getCustomerHistory: async (id: string, page = 1, limit = 10): Promise<PaginatedResponse<any>> => {
    const response = await api.get(`/customers/${id}/history`, { params: { page, limit } });
    return response.data;
  },
};